import { IoMdClose } from 'react-icons/io'
import { IoMenu } from 'react-icons/io5'

interface MenuIconProps {
  onClick: (isActive: boolean) => void
  isMobileMenuOpen: boolean
}

export const MenuIcon = ({ onClick, isMobileMenuOpen }: MenuIconProps) => {
  const setStatus = () => {
    onClick(!isMobileMenuOpen)
  }

  return (
    <button
      id="mobile-menu-toggle"
      type="button"
      onClick={setStatus}
      className="flex min-h-11 min-w-11 items-center justify-center rounded-md bg-transparent border-0 p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
      aria-expanded={isMobileMenuOpen}
      aria-controls="mobile-navigation"
      aria-label={isMobileMenuOpen ? 'Close mobile menu' : 'Open mobile menu'}
    >
      {isMobileMenuOpen ? (
        <IoMdClose size={26} />
      ) : (
        <div>
          <IoMenu size={26} />
        </div>
      )}
    </button>
  )
}
